import { useContext } from 'react';
import { SettingsContext } from '../../context/settingsContext';
// import { SettingsContext } from 'src/@core/context/settingsContext'

export const useSettings = () => useContext(SettingsContext);
